import './App.css';
import MainPage from './components/MainPage/MainPage';

function App() {
  return (
    <div className="App">
        <MainPage />
    </div>
  );
}

export default App;
